module.exports = __webpack_public_path__ + "media/images/arrow-f4a91d2e5d3b464f7d656c83ce972545.svg";